<template>
  <div class="edit-profile-container">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-66">
        <md-card>
          <md-card-header :data-background-color="dataBackgroundColor">
            <h4 class="title">Edit Profile</h4>
            <p class="category">Complete your profile</p>
          </md-card-header>

          <md-card-content>
            <form @submit.prevent="updateProfile">
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-33">
                  <md-field :class="{'md-invalid': errors.email}">
                    <label>Email Address</label>
                    <md-input v-model="emailadress" type="email" required></md-input>
                    <span class="md-error" v-if="errors.email">{{ errors.email }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-33">
                  <md-field :class="{'md-invalid': errors.first_name}">
                    <label>First Name</label>
                    <md-input v-model="firstname" type="text" required></md-input>
                    <span class="md-error" v-if="errors.first_name">{{ errors.first_name }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-33">
                  <md-field :class="{'md-invalid': errors.last_name}">
                    <label>Last Name</label>
                    <md-input v-model="lastname" type="text" required></md-input>
                    <span class="md-error" v-if="errors.last_name">{{ errors.last_name }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <md-field>
                    <label>Address</label>
                    <md-input v-model="address" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-33">
                  <md-field>
                    <label>City</label>
                    <md-input v-model="city" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-33">
                  <md-field>
                    <label>Country</label>
                    <md-input v-model="country" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-33">
                  <md-field>
                    <label>Postal Code</label>
                    <md-input v-model="code" type="text"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <label>About Me</label>
                    <md-textarea v-model="aboutme" :maxlength="500"></md-textarea>
                  </md-field>
                </div>
                
                <div class="md-layout-item md-size-100 text-right">
                  <md-button 
                    type="submit" 
                    class="md-raised md-success"
                    :disabled="loading"
                  >
                    <span v-if="loading">Saving...</span>
                    <span v-else>Update Profile</span>
                  </md-button>
                </div>
              </div>
            </form>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-33">
        <md-card class="md-card-profile">
          <div class="md-card-avatar">
            <img class="img" :src="displayImage" alt="Profile" />
            <input
              type="file"
              ref="profileImageInput"
              @change="onImageChange"
              accept="image/jpeg,image/jpg,image/png"
              style="display: none"
              id="profileImageInput"
            />
            <md-button 
              class="md-icon-button upload-avatar-btn"
              @click="triggerImageUpload"
            >
              <md-icon>add_circle</md-icon>
            </md-button>
          </div>
          <md-card-content>
            <h6 class="category text-gray">{{ userRole || 'User' }}</h6>
            <h4 class="card-title">{{ fullName }}</h4>
            <p class="card-description">
              {{ aboutme || 'Add information about yourself' }}
            </p>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  name: "edit-profile-form",
  props: {
    dataBackgroundColor: {
      type: String,
      default: "green",
    },
  },
  data() {
    return {
      emailadress: null,
      lastname: null,
      firstname: null,
      address: null,
      city: null,
      country: null,
      code: null,
      aboutme: "",
      loading: false,
      errors: {},
      cardUserImage: require("@/assets/img/faces/marc.jpg"),
      profileImageFile: null,
      profileImagePreview: null,
      existingProfileImage: null,
    };
  },
  computed: {
    fullName() {
      if (this.firstname && this.lastname) {
        return `${this.firstname} ${this.lastname}`;
      }
      return this.firstname || this.lastname || 'User';
    },
    userRole() {
      return 'Owner';
    },
    displayImage() {
      // Priority: preview > existing uploaded image > default image
      if (this.profileImagePreview) {
        return this.profileImagePreview;
      }
      // cardUserImage is updated when image is uploaded or loaded
      return this.cardUserImage;
    }
  },
  created() {
    this.getAdminUserProfile();
  },
  beforeDestroy() {
    // Clean up object URL when component is destroyed
    if (this.profileImagePreview) {
      URL.revokeObjectURL(this.profileImagePreview);
    }
  },
  methods: {
    ...mapActions(['getAdminUserData', 'updateAdminUserProfile']),
    getAdminUserProfile() {
      this.getAdminUserData()
        .then(res => {
          if (res && res.data) {
            this.emailadress = res.data.email || '';
            this.firstname = res.data.first_name || '';
            this.lastname = res.data.last_name || '';
            this.address = res.data.profile?.address || '';
            this.city = res.data.profile?.city || '';
            this.country = res.data.profile?.country || '';
            this.code = res.data.profile?.postal_code || '';
            this.aboutme = res.data.profile?.about_me || '';
            this.existingProfileImage = res.data.profile?.profile_image || null;
            // Update cardUserImage with existing profile image if available
            if (this.existingProfileImage) {
              this.cardUserImage = this.existingProfileImage;
            }
          }
        })
        .catch(err => {
          console.error('Error loading profile:', err);
          this.$notify({
            message: 'Failed to load profile data',
            icon: 'error',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        });
    },
    triggerImageUpload() {
      this.$refs.profileImageInput.click();
    },
    onImageChange(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      // Validate file
      if (!this.validateImage(file)) {
        this.$refs.profileImageInput.value = '';
        return;
      }

      this.profileImageFile = file;
      this.profileImagePreview = URL.createObjectURL(file);
      this.errors.profile_image = null;
      
      // Update cardUserImage immediately for preview
      this.cardUserImage = this.profileImagePreview;
      
      // Automatically upload the image
      this.uploadProfileImage();
    },
    uploadProfileImage() {
      if (!this.profileImageFile) {
        return;
      }

      this.loading = true;

      const profileData = {
        email: this.emailadress ? this.emailadress.trim() : '',
        first_name: this.firstname ? this.firstname.trim() : '',
        last_name: this.lastname ? this.lastname.trim() : '',
        address: this.address ? this.address.trim() : '',
        city: this.city ? this.city.trim() : '',
        country: this.country ? this.country.trim() : '',
        postal_code: this.code ? this.code.toString().trim() : '',
        about_me: this.aboutme ? this.aboutme.trim() : '',
        profile_image: this.profileImageFile
      };

      this.updateAdminUserProfile(profileData)
        .then(res => {
          this.loading = false;
          if (res && res.data) {
            // Update existing image if it was uploaded
            if (res.data.profile?.profile_image) {
              this.existingProfileImage = res.data.profile.profile_image;
              // Update cardUserImage with the new uploaded image
              this.cardUserImage = res.data.profile.profile_image;
            }
            // Clear preview after successful upload
            if (this.profileImagePreview) {
              URL.revokeObjectURL(this.profileImagePreview);
              this.profileImagePreview = null;
            }
            this.profileImageFile = null;
            if (this.$refs.profileImageInput) {
              this.$refs.profileImageInput.value = '';
            }
            this.$notify({
              message: 'Profile image updated successfully',
              icon: 'check',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success'
            });
          }
        })
        .catch(err => {
          this.loading = false;
          console.error('Error uploading profile image:', err);
          
          if (err.response && err.response.data) {
            const errorData = err.response.data;
            const errorMessage = errorData.message || 'Failed to upload profile image';
            this.$notify({
              message: errorMessage,
              icon: 'error',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          } else {
            this.$notify({
              message: 'An error occurred while uploading the profile image',
              icon: 'error',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          }
          // Reset on error
          if (this.profileImagePreview) {
            URL.revokeObjectURL(this.profileImagePreview);
            this.profileImagePreview = null;
            this.cardUserImage = this.existingProfileImage || require("@/assets/img/faces/marc.jpg");
          }
          this.profileImageFile = null;
          if (this.$refs.profileImageInput) {
            this.$refs.profileImageInput.value = '';
          }
        });
    },
    validateImage(file) {
      const maxMB = 2;
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

      if (!allowedTypes.includes(file.type)) {
        this.$notify({
          message: 'Only JPG and PNG formats are allowed',
          icon: 'error',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning'
        });
        return false;
      }

      if (file.size > maxMB * 1024 * 1024) {
        this.$notify({
          message: `File size must not exceed ${maxMB} MB`,
          icon: 'error',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning'
        });
        return false;
      }

      return true;
    },
    removeImage() {
      if (this.profileImagePreview) {
        URL.revokeObjectURL(this.profileImagePreview);
      }
      this.profileImageFile = null;
      this.profileImagePreview = null;
      if (this.$refs.profileImageInput) {
        this.$refs.profileImageInput.value = '';
      }
    },
    validateForm() {
      this.errors = {};
      let isValid = true;

      if (!this.emailadress || !this.emailadress.trim()) {
        this.errors.email = 'Email is required';
        isValid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailadress)) {
        this.errors.email = 'Please enter a valid email address';
        isValid = false;
      }

      if (!this.firstname || !this.firstname.trim()) {
        this.errors.first_name = 'First name is required';
        isValid = false;
      }

      if (!this.lastname || !this.lastname.trim()) {
        this.errors.last_name = 'Last name is required';
        isValid = false;
      }

      return isValid;
    },
    updateProfile() {
      if (!this.validateForm()) {
        this.$notify({
          message: 'Please fix the errors in the form',
          icon: 'error',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning'
        });
        return;
      }

      this.loading = true;
      this.errors = {};

      const profileData = {
        email: this.emailadress.trim(),
        first_name: this.firstname.trim(),
        last_name: this.lastname.trim(),
        address: this.address ? this.address.trim() : '',
        city: this.city ? this.city.trim() : '',
        country: this.country ? this.country.trim() : '',
        postal_code: this.code ? this.code.toString().trim() : '',
        about_me: this.aboutme ? this.aboutme.trim() : '',
        profile_image: this.profileImageFile
      };

      this.updateAdminUserProfile(profileData)
        .then(res => {
          this.loading = false;
          if (res && res.data) {
            // Update existing image if it was uploaded
            if (res.data.profile?.profile_image) {
              this.existingProfileImage = res.data.profile.profile_image;
              // Update cardUserImage with the new uploaded image
              this.cardUserImage = res.data.profile.profile_image;
            }
            // Clear preview after successful upload
            if (this.profileImagePreview) {
              URL.revokeObjectURL(this.profileImagePreview);
              this.profileImagePreview = null;
              this.profileImageFile = null;
              if (this.$refs.profileImageInput) {
                this.$refs.profileImageInput.value = '';
              }
            }
            this.$notify({
              message: 'Profile updated successfully',
              icon: 'check',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success'
            });
          }
        })
        .catch(err => {
          this.loading = false;
          console.error('Error updating profile:', err);
          
          if (err.response && err.response.data) {
            const errorData = err.response.data;
            if (errorData.errors) {
              this.errors = errorData.errors;
            }
            const errorMessage = errorData.message || 'Failed to update profile';
            this.$notify({
              message: errorMessage,
              icon: 'error',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          } else {
            this.$notify({
              message: 'An error occurred while updating the profile',
              icon: 'error',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.edit-profile-container {
  padding: 20px;
}

.edit-profile-container .md-layout {
  margin: 0;
}

.edit-profile-container .md-card {
  margin-bottom: 30px;
}

.edit-profile-container .md-card-header {
  padding: 20px;
}

.edit-profile-container .md-card-content {
  padding: 20px;
}

.edit-profile-container .md-field {
  margin-bottom: 20px;
}

.edit-profile-container .text-right {
  text-align: right;
  margin-top: 20px;
}

.edit-profile-container .md-card-profile {
  height: fit-content;
}

.edit-profile-container .md-card-profile .md-card-avatar {
  margin: 0 auto;
  width: 130px;
  height: 130px;
  border-radius: 50%;
  overflow: visible;
  margin-top: -65px;
  position: relative;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42),
    0 4px 25px 0px rgba(0, 0, 0, 0.12),
    0 8px 10px -5px rgba(0, 0, 0, 0.2);
}

.edit-profile-container .md-card-profile .md-card-avatar .img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}

.upload-avatar-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: #527f53a6 !important;
  color: white !important;
  width: 35px;
  height: 35px;
  min-width: 35px;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  border: 2px solid white;
  z-index: 10;
}

.upload-avatar-btn:hover {
  background-color: #45a049 !important;
  transform: scale(1.1);
  transition: transform 0.2s ease;
}

.upload-avatar-btn .md-icon {
  font-size: 24px !important;
  width: 24px;
  height: 24px;
}

.edit-profile-container .md-card-profile .md-card-content {
  text-align: center;
  padding-top: 30px;
}

.edit-profile-container .md-card-profile .card-title {
  margin-top: 10px;
  margin-bottom: 10px;
}

.edit-profile-container .md-card-profile .card-description {
  margin: 15px 0;
  min-height: 60px;
  color: #999;
  font-size: 14px;
  line-height: 1.5;
}

.edit-profile-container .md-button.md-success {
  background-color: #4caf50;
  color: #fff;
}

.edit-profile-container .md-button.md-success:hover {
  background-color: #45a049;
}

.edit-profile-container .md-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.profile-image-upload {
  margin-top: 10px;
}

.upload-label {
  display: inline-block;
  cursor: pointer;
}

.image-preview {
  position: relative;
  display: inline-block;
  margin-top: 15px;
  margin-left: 10px;
  vertical-align: top;
}

.image-preview img {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.remove-image-btn {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #f44336 !important;
  color: white !important;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.remove-image-btn:hover {
  background-color: #d32f2f !important;
}

.md-helper-text {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
  display: block;
}

@media (max-width: 960px) {
  .edit-profile-container {
    padding: 10px;
  }
  
  .edit-profile-container .md-layout-item {
    margin-bottom: 20px;
  }
  
  .image-preview {
    margin-left: 0;
    margin-top: 10px;
  }
}
</style>